<template>
  <div id="app">
    <div class="loading" v-if="$root.loading.do">
      <div class="loading-icon"/>
    </div>
    <transition name="crossfade">
      <div class="transitioning" v-if="$root.transitioning"/>
    </transition>
    <div class="mailresponse" v-if="mailresponse.Message" v-on:click="mailresponse.Message = ''">
      <span v-if="mailresponse.Message=='confirmed'">Ihre E-Mailadresse ist bestätigt. Vielen Dank</span>
      <span v-else-if="mailresponse.Message=='link_error'">Der Bestätigungslink ist ungültig</span>
      <span v-else-if="mailresponse.Message=='sent'">Vielen Dank für Ihr Interesse. Wir haben Ihnen eine E-Mail mit einem Bestätigungslink geschickt.</span>
      <span v-else>{{mailresponse.Message}}</span>
    </div>
    <transition name="fade" mode="out-in">
      <router-view :key="`${$route.name == 'news' || $route.name == 'new' ? 'news' : $route.params.route}`" name="overlay"/>
    </transition>
    <transition name="crossfade" mode="out-in">
      <div class="ks-menu" v-if="$root.Menu === true" @click.stop="$root.Menu = false">
        <transition-group
            name="staggered-fade"
            tag="div"
            appear
            class="ks-roundbox"
            v-bind:css="false"
            v-on:enter="enter"
        >
          <router-link
            v-for="(p, index) in menu"
            :data-index="index"
            :style="{'color': p[1].color}"
            :key="`element-${p[1].route}`"
            :to="{name:p[1].controller, params: {route: p[1].route, id: p[1].id, stub: p[1].stub}}"
          >
            <span
              v-html="p[1].menu"
              @click="$root.scrollOffset = true"
            />
          </router-link>
        </transition-group>
      </div>
    </transition>
    <Switchy/>
    <div class="ks-wrapper" :class="{'ks-wrapper-active': accessActive}">
      <Painter/>
      <Accessibility/>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Painter from '@/components/Painter'
import Switchy from '@/components/Switchy'
//import Applaus from '@/components/Applaus'
import Velocity from 'velocity-animate'
import Accessibility from '@/components/Accessibility'

export default {
  name: 'App',
  components: {
    Switchy,
    Painter,
    Accessibility
    //Applaus
  },
  computed: {
    menu() {
      const asArray = Object.entries(this.$painterdata);
      return asArray.filter(e => e[1].menu)
    }
  },
  data() {
    return({
      accessActive: this.$route.name === 'access',
      mailresponse: {
        Error: "",
        Message: "",
        Form: true,
      }
    });
  },
  async mounted () {
    this.$root.baseNav = this.accessActive ? 'access' : 'home'
    if (this.$route.query.e && this.$route.query.h && this.$route.query.newsletter) {
        let response = await this.$http.post('/newsletter', this.$route.query);
        this.mailresponse = response.data;
    }
    this.$root.$on('access-active', (active) => {
      if (this.accessActive != active) {
        this.accessActive = active
        this.$root.baseNav = this.accessActive ? 'access' : 'home'
        this.$router.push({
          name: this.accessActive ? 'access' : 'home',
          ... this.accessActive
              ? {params: {route: 'access'}}
              : {}
          })
      }
    })
  },
  methods: {
    enter: function (el, done) {
      var delay = el.dataset.index * 150
      setTimeout(function () {
        Velocity(
          el,
          {
            opacity: 1
          },
          {
            mobileHA: false,
            complete: done,
            duration: 100
          }
        )
      }, 500 + delay)
    }
  }
}
</script>


<style lang="scss">

  //@import url('https://fonts.googleapis.com/css2?family=EB+Garamond:ital,wght@0,400;0,700;1,400;1,700&display=swap');
  @import 'main';

  .mailresponse {
    z-index: 1000;
    backdrop-filter: blur(1rem);
    @include flex-vertical-center();
    width: 100%;
    @include vh(100);
    position: fixed;
  }

  .transitioning {
    display: block;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    background: #FFF;
    z-index: 10000;
  }

  .loading {
    z-index: 1001;
    position: fixed;
    left: var(--pd1);
    top: var(--pd1);
    &-icon {
      width: var(--pd1);
      height: var(--pd1);
      &:after {
        content: "⏳";
        position: absolute;
        display: block;
        animation: shake 3s linear infinite;
        font-size: var(--pd2);
      }
    }

    @keyframes shake {
      0% {
          transform:rotate(0deg)
      }
      5% {
          transform:rotate(180deg)
      }
      50% {
          transform:rotate(180deg)
      }
      55% {
          transform:rotate(360deg)
      }
      to {
          transform:rotate(360deg)
      }
    }





  }

  .ks-menu {
    z-index: 1001;
    backdrop-filter: blur(1rem);
    @include flex-vertical-center();
    width: 100%;
    @include vh(100);
    position: fixed;
    padding: 1rem;
    box-sizing: border-box;
    .ks-roundbox {
      display: flex;
      @include flex-vertical-center();
      flex-wrap: wrap;
      @include st() {
        flex-wrap: nowrap;
        flex-direction: column;
        padding: var(--pd2);
      }
      max-width: $wide-container;
      a {
        opacity: 0;
        display: inline-block;
        @include xlargefont;
        line-height: 7rem;
        &:not(:last-child) {
          &:after {
            content: ",";
            margin-right: 1rem;
            @include st() {
              display: none;
            }
          }
        }
      }
    }
  }

  .ks-wrapper {
    /*--min-width: 3rem;*/
    --font-size: 2.3rem;
    @include sd() {
      /*--min-width: 2.6rem;*/
      --font-size: 1.9rem;
    }
    @include st() {
      /*--min-width: 2.4rem;*/
      --font-size: 1.7rem;
    }
    @include sm() {
      /*--min-width: 1.5rem;*/
      --font-size: 1rem;
    }
    --min-width: 0rem;
    --max-width: calc(100vw - var(--min-width));
    --hovertrans: transform 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    transition: transform 0.5s;
    display: flex;
    position: fixed;
    left: 0px;
    top: 0px;
    width: auto;
    overflow: hidden;
    @include vh(100);
    .ks-painter {
      width: var(--max-width);
    }
    .ks-accessibility {
      pointer-events: none;
      width: var(--max-width);
      transition: var(--hovertrans);
      & > div {
        visibility: hidden;
      }
      &:after {
        content: "Barrierefreie Webseite";
        display: block;
        position: absolute;
        transform: rotate(90deg) translateY(calc(-1 * var(--min-width)));
        transform-origin: left top;
        left: 0px;
        top: 0px;
        width: 100vh;
        height: var(--min-width);
        text-align: center;
        display: flex;
        justify-content: center; /* Horizontally center */
        align-items: center; /* Vertically center */
        font: inherit;
        font-size: var(--font-size);
      }
      @media (hover: hover) {
        &:hover {
          transform: translateX(-1rem);
          cursor: pointer;
        }
      }
    }
    &-active {
      transform: translateX(calc(-1 * var(--max-width) + var(--min-width)));
      .ks-accessibility {
        pointer-events: all;
        transition: none;
        & > div {
          visibility: visible;
        }
        &:after {
          display: none;
        }
        @media (hover: hover) {
          &:hover {
            transform: none;
            cursor: default;
          }
        }

      }
      .ks-painter {
        transition: var(--hovertrans);
        cursor: pointer;
        z-index: 2;
        canvas {
          visibility: hidden;
        }
        &:after {
          content: "Schliessen";
          font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
          display: block;
          position: absolute;
          transform-origin: right top;
          right: 0px;
          top: 0px;
          width: 100vh;
          height: var(--min-width);
          text-align: center;
          display: flex;
          justify-content: center; /* Horizontally center */
          align-items: center; /* Vertically center */
          font-size: var(--font-size);
          transform: rotate(-90deg) translateY(calc(-1 * var(--min-width)));
        }
        @media (hover: hover) {
          &:hover {
            transform: translateX(1rem);
            cursor: pointer;
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/App.vue